import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { StatusTag } from '../components/StatusTag';
import './ForecastCard.less';
import { getTextForIrrigationState, getStateForIrrigationState } from './recommendation';

const statusTag = (text, state) => (
  <StatusTag
    width="auto"
    text={text}
    state={state}
    tagStyle={{
      fontSize: '18px',
      minHeight: '42px',
      padding: '8px 16px',
      margin: 0,
    }}
    isCentered
  />
);

export default function ForecastCard({ recommendation }){
  const { t } = useTranslation();
  const forecastDays = String(recommendation?.duration || '').split(' ')[0] || 5;
  return(
    <div className="forecast-card-layout">
      {/* Row 1: Labels */}
      <div className="forecast-card-label forecast-label-left">{t('Current Conditions')}</div>
      <div className="forecast-card-label forecast-label-right">
        {t('{{days}} Day Forecast', { days: forecastDays })}
      </div>

      {/* Row 2: Pills & Divider */}
      <div className="forecast-pill-left">
        {statusTag(getTextForIrrigationState(recommendation?.state),
          getStateForIrrigationState(recommendation?.state))}
      </div>

      <div className="forecast-card-divider">
        <span className="forecast-card-line" />
        <span className="forecast-card-days">{t('{{days}} days', { days: forecastDays })}</span>
        <span className="forecast-card-line" />
        <RightOutlined className="forecast-card-arrow" />
      </div>

      <div className="forecast-pill-right">
        {statusTag(getTextForIrrigationState(recommendation?.forecastState),
          getStateForIrrigationState(recommendation?.forecastState))}
      </div>
    </div>
  );
}

ForecastCard.propTypes = {
  recommendation: PropTypes.shape({
    state: PropTypes.string,
    duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    forecastState: PropTypes.string,
  }),
};

ForecastCard.defaultProps = {
  recommendation: null,
};
